/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EncounterWithEpisodeOfCare } from './EncounterWithEpisodeOfCare';
import {
    EncounterWithEpisodeOfCareFromJSON,
    EncounterWithEpisodeOfCareFromJSONTyped,
    EncounterWithEpisodeOfCareToJSON,
    EncounterWithEpisodeOfCareToJSONTyped,
} from './EncounterWithEpisodeOfCare';

/**
 * 
 * @export
 * @interface FindOneEncounter200Response
 */
export interface FindOneEncounter200Response {
    /**
     * 
     */
    data?: EncounterWithEpisodeOfCare;
}

/**
 * Check if a given object implements the FindOneEncounter200Response interface.
 */
export function instanceOfFindOneEncounter200Response(value: object): value is FindOneEncounter200Response {
    return true;
}

export function FindOneEncounter200ResponseFromJSON(json: any): FindOneEncounter200Response {
    return FindOneEncounter200ResponseFromJSONTyped(json, false);
}

export function FindOneEncounter200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindOneEncounter200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : EncounterWithEpisodeOfCareFromJSON(json['data']),
    };
}

export function FindOneEncounter200ResponseToJSON(json: any): FindOneEncounter200Response {
    return FindOneEncounter200ResponseToJSONTyped(json, false);
}

export function FindOneEncounter200ResponseToJSONTyped(value?: FindOneEncounter200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': EncounterWithEpisodeOfCareToJSON(value['data']),
    };
}

